import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

export const useTracking = (reference, configuration) => {
  const { t } = useI18n();

  const trackingData = computed(() => ({
    itemId: reference.value,
    itemName: t(`EngravingTool.reference.${reference.value}`),
  }));

  const pushOptionSelectedEvent = (event, value, oldValue) => {
    if (value && value !== oldValue) {
      window.tracking.pushEvent(
        window.tracking.getEngravingOptionSelectedTracking(
          event,
          trackingData.value.itemId,
          trackingData.value.itemName,
          value,
        ),
      );
    }
  };

  watch(
    () => configuration.value.engraving,
    (value, oldValue) => {
      pushOptionSelectedEvent('engraving_type_selected', value, oldValue);
    },
  );

  watch(
    () => configuration.value.personalisation.monument,
    (value, oldValue) => {
      pushOptionSelectedEvent('engraving_monument_selected', value, oldValue);
    },
  );

  watch(
    () => configuration.value.personalisation.flower,
    (value, oldValue) => {
      pushOptionSelectedEvent('engraving_flower_selected', value, oldValue);
    },
  );

  watch(
    () => configuration.value.personalisation.sign,
    (value, oldValue) => {
      pushOptionSelectedEvent('engraving_zodiac_selected', value, oldValue);
    },
  );

  watch(
    () => configuration.value.personalisation.font,
    (value, oldValue) => {
      if (configuration.value.engraving === 'initials') {
        pushOptionSelectedEvent('engraving_initial_selected', value, oldValue);
      }
    },
  );

  return {
    trackingData,
  };
};
